import App from 'app/app.js';
import 'app/store/ShoppingCartStore.js';
import 'app/store/JobStore.js';
import 'app/service/TranslateProviderService.js';
import { isAutoApplyCoupon } from '@app/utils/coupon.utils';

function LtShoppingCartSummaryCtrl(
  $scope,
  ShoppingCartStore,
  UserProfileStore,
  RouterService,
  $filter,
  JobStore,
  $window,
  TranslateProviderService,
  $uibModal,
  $location,
  CouponCodeService
) {
  const myFamilyRewards = UserProfileStore.isSubscribed(UserProfileStore.userProfile, 'MyFamilyRewards');
  const myFamilyRewardsMobile = UserProfileStore.isSubscribed(
    UserProfileStore.userProfile,
    'MyFamilyRewardsMobilePhone'
  );
  const url = $location.url();
  this.isLoggedIn =
    UserProfileStore.isLoggedIn() &&
    !UserProfileStore.userProfile.isGuestProfile &&
    myFamilyRewards &&
    myFamilyRewardsMobile;

  // This function continuously monitors for changes in the list of subjects
  // and the index of the active subject in the ShoppingCartStore
  $scope.$watch(
    () => {
      return {
        subjects: ShoppingCartStore.getSubjects(),
        currentSubjectIndex: ShoppingCartStore.getCurrentSubjectIndex()
      };
    },
    (data) => {
      const sortedSubjects = [];
      const currentSubjectIndex = data.currentSubjectIndex;
      data.subjects.forEach((subject) => {
        const subjectIndex = ShoppingCartStore.getSubjectIndex(subject.id);
        if (subjectIndex === currentSubjectIndex) {
          sortedSubjects.unshift(subject);
        } else {
          sortedSubjects.push(subject);
        }
      });
      this.subjects = this.filterEmptySubjects(sortedSubjects);
    },
    true
  );

  this.init = function () {
    this.couponFromShoppingcart = url.includes('shopping-cart');
  };

  this.filterEmptySubjects = (sortedSubjects) =>
    sortedSubjects.filter((order) => order.packages.length + order.addOns.length + order.bundles.length > 0);

  this.enterCouponClick = function (couponCode) {
    $scope.enterCouponClick({ couponCode: couponCode });
    $scope.couponCode = '';
  };

  this.getPlaceholder = function (key) {
    $scope.getPlaceholder({ key: key });
  };

  this.getPlaceholder = function (key) {
    return $filter('ltTranslateFilter')(key);
  };

  this.continueShopping = function (index) {
    $scope.onContinueShopping({ index: index });
  };

  this.getSubjectIndex = function (subjectId) {
    return ShoppingCartStore.getSubjectIndex(subjectId);
  };

  this.getOrderItemCount = function (orderIndex) {
    return ShoppingCartStore.getNumberOfItemsInOrder(orderIndex);
  };

  this.getOrderTotalItemsCount = function () {
    return ShoppingCartStore.getNumberOfItemsInCart();
  };

  this.getOrderSubTotal = function (orderIndex) {
    return ShoppingCartStore.getOrderSubTotal(orderIndex);
  };

  this.getSlashThroughPrices = function (orderIndex) {
    return ShoppingCartStore.getSlashThroughPrices(orderIndex);
  };

  this.getOrderSubTotalWithSlash = function (orderIndex) {
    return ShoppingCartStore.getOrderSubTotal(orderIndex) + ShoppingCartStore.getSlashThroughPrices(orderIndex);
  };

  this.getAllItemsSubTotal = function () {
    return ShoppingCartStore.getAllItemsSubTotal();
  };

  this.getOrderPromotionAmount = function (orderIndex) {
    return ShoppingCartStore.getOrderPromotionAmount(orderIndex);
  };

  this.getOrderShippingPrice = function () {
    return ShoppingCartStore.getShippingUnitPrice();
  };

  this.getOrderTotal = function (orderIndex) {
    return ShoppingCartStore.getOrderTotal(orderIndex);
  };

  this.getCartTotal = function () {
    return ShoppingCartStore.getTotalWithoutTax();
  };

  this.goToMyAccount = function () {
    RouterService.goToMyAccount();
  };

  this.removeCouponClick = function (coupon, couponCodeDesc) {
    $window.scrollTo({ top: 0, behavior: 'smooth' });
    $scope.removeCouponClick({ coupon, couponCodeDesc });
  };

  this.isCouponAvailable = function () {
    var available = false;
    R.forEach(
      function (coupon) {
        if (!!coupon && !!coupon.promotions) {
          available = true;
        }
      }.bind(available),
      $scope.coupons
    );
    return available;
  };

  this.getCouponPromotionAmount = function (couponIndex) {
    return ShoppingCartStore.getCouponPromotionAmount(couponIndex);
  };

  this.getInstantSavings = function (orderIndex) {
    return ShoppingCartStore.getInstantSavings(orderIndex);
  };

  this.getCouponCodeDesc = function (couponCode) {
    var key = couponCode;
    // check if any '-' in coupon to get content key for batch value.
    var couponCodeKey = key.split('-');
    if (couponCodeKey.length > 1 && $filter('ltTranslateFilter')(couponCodeKey[0])) {
      return $filter('ltTranslateFilter')(couponCodeKey[0]);
    }

    return $filter('ltTranslateFilter')(key) || $filter('ltTranslateFilter')('COUPON_DEFAULT_DESC');
  };

  this.isNonSpectrumEnabled = function (subject) {
    var job = JobStore.getJob(subject.portraitDashboard.jobKey);
    return job ? !job.spectrumEnabled : false;
  };

  this.isCanadianDomain = function () {
    return TranslateProviderService.isCanadianDomain();
  };

  this.getFees = function () {
    return ShoppingCartStore.getFees();
  };

  this.isAutoApplyCoupon = (coupon) => isAutoApplyCoupon(coupon);
  this.getRegularCouponCount = ShoppingCartStore.getRegularCouponCount;
  this.isPromotionalCoupon = (coupon) => CouponCodeService.isPromotionalCoupon(coupon);
  this.getDisplayCouponCode = (coupon) => CouponCodeService.getDisplayCouponCode(coupon);
}

App.controller('LtShoppingCartSummaryCtrl', [
  '$scope',
  'ShoppingCartStore',
  'UserProfileStore',
  'RouterService',
  '$filter',
  'JobStore',
  '$window',
  'TranslateProviderService',
  '$uibModal',
  '$location',
  'CouponCodeService',
  LtShoppingCartSummaryCtrl
]);
